/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronRightEnd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.739 5 14 12l-6.261 7L6 17.65 11.054 12 6 6.35zM18 5v14h-2V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronRightEnd as ChevronRightEnd };
